import { Component, OnInit, Input, inject } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngxs/store';
import { NearbySchoolsState } from '../../nearby-schools.state';
import { NearbySchoolsActions } from '../../nearby-schools.actions';
import { IApplicationContent } from '../../../types';
import { DotNetDatePipe } from '../../../pipes/dot-net-date.pipe';
import { RootState } from '../../../store/root.state';
import { NgClass, NgIf } from '@angular/common';
import { IAppSettings, APP_CONFIG } from '@nha/config/interfaces/iapp-settings.interface';

@Component({
    selector: 'app-nearby-schools-list-item',
    templateUrl: './nearby-schools-list-item.component.html',
    styleUrls: ['./nearby-schools-list-item.component.scss'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, NgClass, NgIf]
})
export class NearbySchoolsListItemComponent implements OnInit {
	appSettings = inject<IAppSettings>(APP_CONFIG);
	
	@Input() schoolControl: AbstractControl;
	@Input() formGroup: UntypedFormGroup;
	@Input() listItemIndex: number;
	@Input() academicYearApplying: number;
	@Input() hiddenMobile: boolean;

	public isSelected: boolean;
	public today: Date;
	public kenticoUrl: string = this.appSettings.web.schoolSites;
	public appContent = { resourceStrings: {} } as IApplicationContent;

	constructor(
		private dotNetDatePipe: DotNetDatePipe,
		private store: Store
	) {}

	get gradeLevelControl(): UntypedFormControl {
		return this.schoolControl.get('gradeLevelId') as UntypedFormControl;
	}

	ngOnInit(): void {
		this.store.select(RootState.content).subscribe((content) => {
			if (content) {
				this.appContent = content;
			}
		});

		this.store.select(NearbySchoolsState.selectedSchoolID).subscribe((selectedSchoolID) => {
			this.isSelected = selectedSchoolID === this.schoolControl.get('schoolID').value;
		});
	}

	addSchoolToApply() {
		(this.schoolControl as UntypedFormGroup).controls.isApplying.setValue(true);
	}

	removeSchoolToApply() {
		(this.schoolControl as UntypedFormGroup).controls.isApplying.setValue(false);
		this.schoolControl.get('gradeLevelId').setValidators([]);
		this.schoolControl.get('gradeLevelId').reset();
	}

	selectSchool() {
		if (this.isSelected) {
			this.store.dispatch(new NearbySchoolsActions.SelectNearbySchool(null));
		} else {
			this.store.dispatch(new NearbySchoolsActions.SelectNearbySchool(this.schoolControl.get('schoolID').value));
		}
	}
}
